import React from "react"
import KundendienstNavigation from "./navigationComponent/KundendienstNavigation"
import CustomerTypeSelection from "./navigationComponent/CustomerTypeSelection"
import {selectionType} from "./navigationComponent/customerSelection"

const KundendienstContent = () => {
	return (
		<>
			<section className="container">
				<div className="row align-items-center justify-content-center my-5">
					<div className="col-12 col-md-8">
						<KundendienstNavigation />
						<CustomerTypeSelection selectionType={selectionType.customerTypeSelection} />
					</div>
				</div>
			</section>

		</>
	)
}

export default KundendienstContent
